module.exports = __webpack_public_path__ + "/75f98df66bb2e59661d84d985a4d64d4.png";